import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { debounce } from 'lodash';

export default class MultilineTrim extends PureComponent {
  static propTypes = {
    // Note: Only single string is supported
    children: PropTypes.string,
    maxLines: PropTypes.number.isRequired,
    trimMargin: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
  };

  static defaultProps = {
    trimMargin: 5,
  };

  state = {
    text: this.props.children,
    trimmed: false,
  };

  componentDidMount() {
    this.trimContentIfNeeded();
    window.addEventListener('resize', this.debouncedTrimContentIfNeeded);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedTrimContentIfNeeded);
  }

  trimContentIfNeeded = () => {
    const element = this.wrapper;

    if (!element) {
      return;
    }

    this.lineHeight = (
      this.lineHeight
      || parseInt(window.getComputedStyle(element, null)['line-height'], 10)
    );

    const numberOfLines = Math.round(element.offsetHeight / this.lineHeight);

    if (!this.props.maxLines || numberOfLines <= this.props.maxLines) {
      return;
    }

    this.setState((state, props) => {
      const { maxLines, trimMargin } = props;
      const avgCharactersPerLine = Math.floor(state.text.length / numberOfLines);
      const proposedLength = avgCharactersPerLine * maxLines - trimMargin;

      return {
        text: state.text.slice(0, proposedLength).replace(/[\s|,.:;-]+$/, ''),
        trimmed: true,
      };
    });
  };

  debouncedTrimContentIfNeeded = debounce(this.trimContentIfNeeded, 400);

  render() {
    const { text, trimmed } = this.state;

    return (
      <span ref={ref => { this.wrapper = ref; }}>
        {text}{trimmed && '…'}
      </span>
    );
  }
}
